// extracted by mini-css-extract-plugin
export default {"container":"tenantNumerationSchemasList_container__V0Zic"};